import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {FormDataUpload, NestApiProvider} from '../../nest-api';
import {
  RequestCreateAndUpdateLocationDto,
  RequestDeleteLocationByDto,
  RequestFindAllLocationDto,
  ResponseCreateLocationDto,
  ResponseDeleteLocationByDto,
  ResponseFindAllLocationDto,
  ResponseUpdateLocationDto
} from '../dto/attendance-location.dto';

@Injectable()
export class AttendanceLocationApi {

  private service: string = '';
  private model: string = 'attendanceLocation';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadTemplate(): Observable<any> {
    const _method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(_method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(_method, url, func, params, body);
  }

  public downloadTemplateEmployee(queryParams): Observable<any> {
    const _method: string = 'GET';
    const func: string = 'downloadTemplateAttLocEmp';
    const params: any = {};
    const urlParams: any = {workLocationCode: queryParams};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(_method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(_method, url, params, body);
  }

  public uploadAttendanceLocation(file: File): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadAttendanceLocation';
    const params: FormDataUpload[] = [];
    params.push({name: 'file', value: file});
    const urlParams: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, url, params);
  }

  public uploadEmployeeAttendanceLocation(attLocCode: any, file: File): Observable<any> {
    const method: string = 'POST';
    const func: string = 'processUploadAttendanceLocationEmp';
    const params: FormDataUpload[] = [];
    params.push({name: 'file', value: file});
    const urlParams: any = {attLocCode: attLocCode};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, url, params);
  }


  public findAllLocation(payload: RequestFindAllLocationDto): Observable<ResponseFindAllLocationDto> {
    const method: string = 'GET';
    const func: string = 'findAllLocation';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFindAllLocationDto>(method, url, func, params, body);
  }

  public createLocation(data: RequestCreateAndUpdateLocationDto): Observable<ResponseCreateLocationDto> {
    const method: string = 'POST';
    const func: string = 'createLocation';
    const params: RequestCreateAndUpdateLocationDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCreateLocationDto>(method, url, params, urlParams, body);
  }

  public updateLocation(data: RequestCreateAndUpdateLocationDto): Observable<ResponseUpdateLocationDto> {
    const method: string = 'POST';
    const func: string = 'updateLocation';
    const params: RequestCreateAndUpdateLocationDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseUpdateLocationDto>(method, url, params, urlParams, body);
  }

  public deleteLocationBy(data: RequestDeleteLocationByDto): Observable<ResponseDeleteLocationByDto> {
    const method: string = 'POST';
    const func: string = 'deleteLocationBy';
    const params: RequestDeleteLocationByDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteLocationByDto>(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-location.api.ts